import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common'
import * as moment from 'moment';
import { start } from 'repl';

@Pipe({ name: 'dateFormatWithTimeZone' })
export class DateFormatWithTimeZonePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {

  }

  transform(input: any, type: any) {

    if (input) {
      let d = new Date(input);
      let currentDate = moment(input).format('YYYY-MM-DD');
      let date;
      let presentDate = moment().format('YYYY-MM-DD');

      if (type == "date") {

        let supportedFormats = ['YYYY-MM-DD', 'M/D/YY', 'MM/DD/YY', 'M/DD/YY', 'YYYY-MM-DDTHH:mm:ss.SSSZ']; // Add more formats as needed
        let processedInput;
        let finaldate;
        let presentDate = moment().utc().format('YYYY-MM-DD');

        for (let format of supportedFormats) {
          processedInput = moment.utc(input, format, true);
          if (processedInput.isValid()) {
            currentDate = processedInput.format('YYYY-MM-DD');
            break;
          }
        }

        if (presentDate == currentDate) {
          return 'Today';
        } else if (moment(currentDate).add(1, 'd').isSame(presentDate, 'day')) {
          return 'Yesterday';
        } else if (moment(currentDate).isAfter(presentDate, 'day') && moment(currentDate).isBefore(moment(presentDate).add(4, 'd'), 'day')) {
          let date = moment(input).utc().format('dddd');
          return date;
        } else {

          for (let format of supportedFormats) {
            processedInput = moment.utc(input, format, true);
            if (processedInput.isValid()) {
              finaldate = processedInput.format('MM/DD/YYYY');
              return finaldate;
            }
          }
        }
      }

      else if (type == "dateTime") {
        let finaldate;
        if (presentDate == currentDate) {
          date = new DatePipe('en-US').transform(d, 'h:mm a');
          finaldate = 'Today' + ' ' + date;
          return finaldate;
        }
        else {
          let d = new Date(input);
          // d.setMinutes( d.getMinutes() + d.getTimezoneOffset() );
          finaldate = this.datePipe.transform(d, "M/d/yy, h:mm a");
          return finaldate;
        }

      } else if (type == 'overview') {
        return moment(input).format('MMMM D,YYYY');
      } else if (type == 'dateProposal') {
        return moment(input).format('MMM. D,YYYY');
      } else if (type == 'dateInvoice') {
        return moment(input).format('MM-DD-YYYY');
      } else if (type) {
        return moment(input).format(type);
      }
      else {
        return input;
      }
    }
    else {
      return "";
    }

  }
}
